var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAddTracks(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 21,
    viewBox: "0 0 22 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 11.0129L15 9.76288V12.9775C14.556 12.754 14.0424 12.6275 13.5 12.6275C11.8703 12.6275 10.5 13.7695 10.5 15.2525C10.5 16.7356 11.8703 17.8775 13.5 17.8775C15.1297 17.8775 16.5 16.7356 16.5 15.2525V3.49219L6 5.24219V13.7275C5.55603 13.504 5.04238 13.3775 4.5 13.3775C2.87031 13.3775 1.5 14.5195 1.5 16.0025C1.5 17.4856 2.87031 18.6275 4.5 18.6275C6.12969 18.6275 7.5 17.4856 7.5 16.0025V11.0129ZM6 16.002C6 16.5899 5.35559 17.127 4.5 17.127C3.64441 17.127 3 16.5899 3 16.002C3 15.414 3.64441 14.877 4.5 14.877C5.35559 14.877 6 15.414 6 16.002ZM13.5 16.377C14.3556 16.377 15 15.8399 15 15.252C15 14.664 14.3556 14.127 13.5 14.127C12.6444 14.127 12 14.664 12 15.252C12 15.8399 12.6444 16.377 13.5 16.377ZM7.5 9.49298V6.51367L15 5.26367V8.24298L7.5 9.49298Z",
    fill: "#1B0076"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9372 1.89258V1.14258H17.1872H15.8122H15.0622V1.89258V4.12174H12.833H12.083V4.87174V6.24675V6.99675H12.833H15.0622V9.22591V9.97591H15.8122H17.1872H17.9372V9.22591V6.99675H20.1663H20.9163V6.24675V4.87174V4.12174H20.1663H17.9372V1.89258Z",
    fill: "#1B0076",
    stroke: "#F2F5F7",
    strokeWidth: 1.5
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddTracks);
export default __webpack_public_path__ + "static/media/add-tracks.2921960d.svg";
export { ForwardRef as ReactComponent };